import {createStore, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import {createLogger} from 'redux-logger';
import rootReducer from './../reducers';
import {subscriptionMiddleware} from './subscriptionMiddleware';

export default function configureStore(initialState) {
  const middleware = [thunk, createLogger(), subscriptionMiddleware];
  const store = createStore(rootReducer, initialState, applyMiddleware(...middleware));

  return store;
}
